import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { fmtDT } from "@/lib/brand";

const TABS = [["", "All"], ["host", "Host & Earn"], ["business", "Business"], ["support", "Support"]];

export default function AdminEnquiries() {
  const api = useApi();
  const [type, setType] = useState("");
  const [list, setList] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/enquiries", { params: type ? { type } : {} }).then((r) => setList(r.data));
  }, [api, type]);
  useEffect(() => {
    load();
  }, [load]);
  const close = async (id) => {
    try { await api.patch(`/admin/enquiries/${id}`); toast.success("Marked as contacted"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6" data-testid="admin-enquiries">
      <h1 className="text-3xl font-semibold tracking-tight">Enquiries</h1>
      <div className="flex flex-wrap gap-2">
        {TABS.map(([v, l]) => (
          <button key={l} onClick={() => setType(v)} data-testid={`enquiry-tab-${v || "all"}`}
            className={`rounded-md px-3 py-1.5 text-sm ${type === v ? "bg-[#FF5A00] text-white" : "bg-white/5 text-neutral-400 hover:text-white"}`}>{l}</button>
        ))}
      </div>
      <div className="overflow-x-auto rounded-lg border border-white/10 bg-[#141414]">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-neutral-500">
            <tr>{["Type", "Contact", "Details", "Received", "Status"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {list.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-neutral-500" data-testid="enquiries-empty">No enquiries yet.</td></tr>}
            {list.map((q) => (
              <tr key={q.id} data-testid={`enquiry-row-${q.id}`}>
                <td className="px-4 py-3 capitalize">{q.type}</td>
                <td className="px-4 py-3"><p className="font-medium">{q.name}</p><p className="text-xs text-neutral-500">{q.phone}{q.email && ` · ${q.email}`}</p></td>
                <td className="max-w-sm px-4 py-3 text-xs text-neutral-300">{[q.company, q.car, q.city].filter(Boolean).join(" · ")}{q.message && <p className="mt-1 text-neutral-500">{q.message}</p>}</td>
                <td className="px-4 py-3 text-xs text-neutral-400">{fmtDT(q.created_at)}</td>
                <td className="px-4 py-3">
                  {q.status === "NEW"
                    ? <button onClick={() => close(q.id)} data-testid={`enquiry-close-${q.id}`} className="rounded-md bg-[#FF5A00] px-3 py-1 text-xs font-semibold text-white">Mark contacted</button>
                    : <span className="text-xs text-emerald-400">Contacted</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
